import { SUPPORT_MODAL_SHOW, SUPPORT_DEPOSIT_RELOAD } from "../../support/actions";
import { daUtil } from "../../../api";
import Notifications from "react-notification-system-redux";

export const DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD = 'DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD';
export const DISPATCH_DRIVER_DEPOSIT_DRIVER_LOADED = 'DISPATCH_DRIVER_DEPOSIT_DRIVER_LOADED';
export const DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD = 'DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD';
export const DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOADED = 'DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOADED';
export const DISPATCH_DRIVER_DEPOSIT_MAKE_RETURN = 'DISPATCH_DRIVER_DEPOSIT_MAKE_RETURN';
export const DISPATCH_DRIVER_DEPOSIT_CANCEL_RETURNED = 'DISPATCH_DRIVER_DEPOSIT_CANCEL_RETURNED';
export const DISPATCH_DRIVER_DEPOSIT_CANCEL_RECEIVED = 'DISPATCH_DRIVER_DEPOSIT_CANCEL_RECEIVED';
export const DISPATCH_DRIVER_DEPOSIT_CANCEL_INVOICED = 'DISPATCH_DRIVER_DEPOSIT_CANCEL_INVOICED';
export const DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD = 'DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD';
export const DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOADED = 'DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOADED';
export const DISPATCH_DRIVER_DEPOSIT_ORDER_MAKE_RETURN = 'DISPATCH_DRIVER_DEPOSIT_ORDER_MAKE_RETURN';

export const act_loadDepositDriver = (driver_id, offset) => {
  return {
    type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD,
    driver_id: driver_id,
    offset: offset
  };
};

export const act_loadDepositDrivers = (offset) => {
  return {
    type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD,
    offset: offset
  };
};

export const act_loadDepositProductsDetail = (offset) => {
  return {
    type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD,
    offset: offset
  };
};

export const driverDepositMakeReturn = (driver_id, product_id, quantity) => {
  return {
    "type": DISPATCH_DRIVER_DEPOSIT_MAKE_RETURN,
    "driver_id": driver_id,
    "product_id": product_id,
    "quantity": quantity
  };
};

export const driverDepositCancelReturned = (driver_id, deposit_driver_id) => {
  return {
    "type": DISPATCH_DRIVER_DEPOSIT_CANCEL_RETURNED,
    "driver_id": driver_id,
    "deposit_driver_id": deposit_driver_id,
  };
};

export const driverDepositCancelInvoiced = (driver_id, deposit_driver_id) => {
  return {
    "type": DISPATCH_DRIVER_DEPOSIT_CANCEL_INVOICED,
    "driver_id": driver_id,
    "deposit_driver_id": deposit_driver_id,
  };
};

export const act_showPopinConfirm = (msg, dispatchDatas) => {
  return {
    "type": SUPPORT_MODAL_SHOW,
    "modalData": {
      "modalType": "popin_confirm",
      "msg": msg,
      "title": 'Veuillez confirmer votre action',
      "dispatchDatas": dispatchDatas,
    }
  };
};

export const driverDepositCancelReceived = (driver_id, deposit_driver_id, deposit_user_id, user_id) => {
  let trigger_action_type = DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD;
  if (typeof(user_id) !== 'undefined') {
    trigger_action_type = SUPPORT_DEPOSIT_RELOAD;
  }
  return {
    "type": DISPATCH_DRIVER_DEPOSIT_CANCEL_RECEIVED,
    "driver_id": driver_id,
    "deposit_driver_id": deposit_driver_id,
    "deposit_user_id": deposit_user_id,
    "trigger_action_type": trigger_action_type,
    "user_id": user_id,
  };
};

export const driverDepositOrderMakeReturn = (driver_id, order_id) => ({
  type: DISPATCH_DRIVER_DEPOSIT_ORDER_MAKE_RETURN,
  driver_id,
  order_id
});

// Nouvelles actions pour la facturation instantanée et le déblocage
export const DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE = 'DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE';
export const DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_PRODUCT = 'DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_PRODUCT';
export const DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_ORDER = 'DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE_ORDER';
export const DISPATCH_DRIVER_DEPOSIT_UNLOCK = 'DISPATCH_DRIVER_DEPOSIT_UNLOCK';

export const driverDepositInstantInvoice = (driver_id, center_id) => ({
  type: DISPATCH_DRIVER_DEPOSIT_INSTANT_INVOICE,
  driver_id,
  center_id,
});

export const driverDepositInstantInvoiceProduct = (driver_id, product_id, deposit_label, quantity, center_id, reason = "") => {
  // Retourner un thunk qui fait l'appel API directement et retourne une Promise
  return async (dispatch, getState) => {
    const state = getState();
    const centerId = center_id || (state.dispatch && state.dispatch.metas && state.dispatch.metas.current_center_id);

    const datas = {
      'driver_id': driver_id,
      'center_id': centerId,
      'product_id': product_id || null,
      'deposit_label': deposit_label || null,
      'quantity': quantity,
      'reason': reason || "",
    };

    try {
      // Utiliser l'endpoint de facturation en bulk avec une liste d'un seul élément
      await daUtil.post('/depositdriver/invoice_deposit_bulk/', { driver_id: datas.driver_id, invoices: [{ product_id: datas.product_id, deposit_label: datas.deposit_label, quantity: datas.quantity, reason: datas.reason }], center_id: datas.center_id });

      dispatch(Notifications.success({
        title: "Facturation produit",
        message: `Produit facturé avec succès (${quantity} unité${quantity > 1 ? 's' : ''})`,
        autoDismiss: 3,
        dismissible: "click"
      }));

      // Recharger les données du livreur
      dispatch({driver_id, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
      dispatch({type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD});
      dispatch({type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD});

      return { success: true };
    } catch (error) {
      const errorMessage = error.response && error.response.data.detail ? error.response.data.detail : error.message;
      dispatch(Notifications.error({
        title: "Une erreur est survenue",
        message: errorMessage,
        autoDismiss: 5,
        dismissible: "click"
      }));
      throw error;
    }
  };
};

export const driverDepositInstantInvoiceOrder = (driver_id, order_id, center_id, reason = "") => {
  // Retourner un thunk qui fait l'appel API directement et retourne une Promise
  return async (dispatch, getState) => {
    const state = getState();
    const centerId = center_id || (state.dispatch && state.dispatch.metas && state.dispatch.metas.current_center_id);

    const datas = {
      'driver_id': driver_id,
      'center_id': centerId,
      'order_id': order_id,
      'reason': reason || "",
    };

    try {
      await daUtil.post('/depositdriver/instant_invoice_order/', datas);

      dispatch(Notifications.success({
        title: "Facturation commande",
        message: "Commande facturée avec succès",
        autoDismiss: 3,
        dismissible: "click"
      }));

      // Recharger les données du livreur
      dispatch({driver_id, type: DISPATCH_DRIVER_DEPOSIT_DRIVER_LOAD});
      dispatch({type: DISPATCH_DRIVER_DEPOSIT_DRIVERS_LOAD});
      dispatch({type: DISPATCH_DRIVER_DEPOSIT_PRODUCTS_DETAIL_LOAD});

      return { success: true };
    } catch (error) {
      const errorMessage = error.response && error.response.data.detail ? error.response.data.detail : error.message;
      dispatch(Notifications.error({
        title: "Une erreur est survenue",
        message: errorMessage,
        autoDismiss: 5,
        dismissible: "click"
      }));
      throw error;
    }
  };
};

export const driverDepositUnlock = (driver_id, center_id, reason = "", deposit_label = null, quantity = null, order_id = null) => ({
  type: DISPATCH_DRIVER_DEPOSIT_UNLOCK,
  driver_id,
  center_id,
  reason,
  deposit_label,
  quantity,
  order_id,
});

// Nouvelle action simplifiée pour le déblocage global du livreur
export const driverUnlock = (driver_id, reason = "") => ({
  type: DISPATCH_DRIVER_DEPOSIT_UNLOCK,
  driver_id,
  reason,
});
